import React from 'react'
import { Button, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { usePromotions } from './promotions-context'

const useStyles = makeStyles(theme => ({
  notice: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    padding: theme.spacing(0.5, 2),
    color: theme.palette.text.secondary,
    '&::before, &::after': {
      content: '""',
      flex: 1,
      height: 1,
      backgroundColor: theme.palette.divider,
    },
  },
  text: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    whiteSpace: 'nowrap',
  },
}))

/**
 * Quiet divider at the end of the thread recording that the golfer turned
 * promotions off, with an Undo. Session-only: it is client state, not a message.
 */
const PromotionsOffNotice = () => {
  const classes = useStyles()
  const promotions = usePromotions()
  if (!promotions?.showTurnedOffNotice) return null

  const { coachName, saving, turnOn } = promotions

  return (
    <div className={classes.notice} data-testid="promotions-off-notice">
      <Typography variant="caption" className={classes.text}>
        You turned off promotions from {coachName} &middot;
        <Button size="small" color="primary" disabled={saving} onClick={turnOn}>
          Undo
        </Button>
      </Typography>
    </div>
  )
}

export default PromotionsOffNotice
